import React from 'react';
import { BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CustomPasswordInput from 'components/CustomInput/CustomPasswordInput';
import LockOutlined from '@material-ui/icons/LockOutlined';
import Rule from 'components/Rule/Rule';
import styles from 'assets/jss/material-dashboard-pro-react/views/settingsSubpageStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IResetPasswordTabProps {
	setPassword: React.Dispatch<React.SetStateAction<string>>;
	setConfirmPassword: React.Dispatch<React.SetStateAction<string>>;
	confirmPassword: string;
	password: string;
	rules: {
		name: string;
		success: boolean;
	}[];
}

const ResetPasswordTab = ({
	setPassword,
	setConfirmPassword,
	confirmPassword,
	password,
	rules,
}: IResetPasswordTabProps) => {
	const classes = useStyles();

	return (
		<div className={classes.resetAdslPasswordTab}>
			<div className={classes.rulesWrapper}>
				<BodyM>{translate('passwordForm.subheader')}</BodyM>
				{rules.map((rule) => (
					<Rule showErrors={false} key={rule.name} {...rule} />
				))}
			</div>
			<CustomPasswordInput
				labelText={translate('number.settings.new.password')}
				id="new_password"
				formControlProps={{
					fullWidth: true,
				}}
				error={false}
				icon={<LockOutlined />}
				inputProps={{
					onChange: (event: React.FormEvent<HTMLInputElement>) =>
						setPassword((event.target as HTMLInputElement).value),
					required: true,
					value: password,
					type: 'password',
					autoComplete: 'off',
				}}
			/>
			<CustomPasswordInput
				labelText={translate('number.settings.confirm.new.password')}
				id="confirm_password"
				formControlProps={{
					fullWidth: true,
				}}
				error={false}
				icon={<LockOutlined />}
				inputProps={{
					onChange: (event: React.FormEvent<HTMLInputElement>) =>
						setConfirmPassword((event.target as HTMLInputElement).value),
					required: true,
					value: confirmPassword,
					type: 'password',
					autoComplete: 'off',
				}}
			/>
		</div>
	);
};

export default ResetPasswordTab;
